
import Vue from 'vue'

const component = Vue.extend({
  props: {
    value: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'primary'
    },
    hash: {
      type: String,
      default: 'icon'
    },
    size: {
      type: [Number, String],
      default: 20
    },
    width: {
      type: [Number, String],
      default: null
    },
    height: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    __style() {
      const regx = /^#(.+)/
      const fill = regx.test(this.color) ? this.color : `var(--v-${this.color}-base)`
      return { fill }
    },
    __width() {
      return this.width || this.size
    },
    __height() {
      return this.height || this.size
    }
  }
})

Vue.component('AIcon', component)
export default component
